import Resource from '@/services/resources/common';

export default class AccountTypeResource extends Resource {
  constructor(entrypoint = '/account_types', alias = 'AccountType') {
    super(entrypoint, alias);
  }
}
